import { render, staticRenderFns } from "./RetrainingEventOrder.vue?vue&type=template&id=2aeefb2a&scoped=true"
import script from "./RetrainingEventOrder.vue?vue&type=script&lang=js"
export * from "./RetrainingEventOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aeefb2a",
  null
  
)

export default component.exports